import React, { Component, useRef, useState } from "react"
import { Asset, Link } from "../../../plugins/gatsby-plugin-atollon"
import parse from "html-react-parser"
import StructuredText from "../structured-text/custom-structured-text-renderer"
import { Check, LeftArrowSlider, Location, RightArrowSlider, Download } from "../icons"
import Slider from "react-slick"
import FsLightbox from 'fslightbox-react'

const slugify = (text) => {
  return text.toString().toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w-]+/g, '')       // Remove all non-word chars
    .replace(/--+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')           // Trim - from start of text
    .replace(/-+$/, '')           // Trim - from end of text
}

const EventCard = (props) => {
  const slider = useRef()
  const [floorplanLightbox, setFloorplanLightbox] = useState(false);
  const [imageLightbox, setImageLightbox] = useState({
    toggler: false,
    slide: 1,
  });

  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 500,
    arrow: true,
  }

  const permalink = `${props.venue?.permalink}#${slugify(props.title)}`

  return (
    <div className="card card--event" data-sal="slide-up" data-sal-duration="1000"
          data-sal-easing="ease" id={slugify(props.title)}>
      <div className="card--event__gallery">
        <Slider ref={slider} {...settings}>
          {
            props.gallery?.length > 0 && props.gallery.map((image, i) => (
              <Asset asset={image} />
            ))
          }
        </Slider>
        { props.gallery?.length > 1 &&
          <div className="card--event__arrows">
            <button onClick={() => slider.current.slickPrev()}><LeftArrowSlider /></button>
            <button onClick={() => slider.current.slickNext()}><RightArrowSlider /></button>
          </div>
        }
      </div>

      { props.template &&
        <div className="card--event__content">
          {props.title && <h3>{parse(props.title)}</h3>}
          {props.eventType && <span className='card--event__type'>{props.eventType}</span>}
          {props.richContent && <StructuredText data={props.richContent} />}
          <div className="card--event__wrapper">
            <div className="card--event__stats">
              <ul>
                {props.stands && <li>stands <span>{props.stands}</span></li>}
                {props.seats && <li>Seats <span>{props.seats}</span></li>}
              </ul>
            </div>
            {
              props.notableFeatures?.length > 0 &&
              <div className="card--event__feature">
                <h4>Notable Features</h4>
                <ul>
                  {
                    props.notableFeatures.slice(0, 4).map((feature, i) => (
                      <li key={i}><span><Check /></span> {feature.title}</li>
                    ))
                  }
                </ul>
              </div>
            }
          </div>

          { (props.button?.length > 0 || props.floorplans?.length > 0) &&
            <div className="card--event__button">
              { props.floorplans?.length > 0 &&
                <button
                  type="button"
                  className="btn btn--border"
                  onClick={() => setFloorplanLightbox(!floorplanLightbox)}
                >
                  Floorplans
                </button>
              }
              {
                props.button?.length > 0 && props.button[0].link?.length > 0 &&
                <Link
                  className="btn btn--umber"
                  to={props.button[0].link[0].externalLink ? props.button[0].link[0].externalLink : props.button[0].link[0].internalLink.permalink}>
                  {props.button[0]?.title}
                </Link>
              }
            </div>
          }
        </div>
      }
      { !props.template && 
        <Link to={permalink} className="card--event__content">
        {props.title && <h3>{parse(props.title)}</h3>}
        {props.eventType && <span className='card--event__type'>{props.eventType}</span>}
        {props.richContent && <StructuredText data={props.richContent} />}
        <div className="card--event__wrapper">
          <div className="card--event__stats">
            <ul>
              {props.stands && <li>stands <span>{props.stands}</span></li>}
              {props.seats && <li>Seats <span>{props.seats}</span></li>}
            </ul>
          </div>
          {
            props.notableFeatures?.length > 0 &&
            <div className="card--event__feature">
              <h4>Notable Features</h4>
              <ul>
                {
                  props.notableFeatures.slice(0, 4).map((feature, i) => (
                    <li key={i}><span><Check /></span> {feature.title}</li>
                  ))
                }
              </ul>
            </div>
          }
        </div>

        { (props.button?.length > 0 || props.floorplans?.length > 0) &&
          <div className="card--event__button">
            { props.floorplans?.length > 0 &&
              <button
                type="button"
                className="btn btn--border"
                onClick={() => setFloorplanLightbox(!floorplanLightbox)}
              >
                Floorplans
              </button>
            }
            {
              props.button?.length > 0 && props.button[0].link?.length > 0 &&
              <Link
                className="btn btn--umber"
                to={props.button[0].link[0].externalLink ? props.button[0].link[0].externalLink : props.button[0].link[0].internalLink.permalink}>
                {props.button[0]?.title}
              </Link>
            }
          </div>
        }
      </Link>
      }
      { props.floorplans?.length > 0 &&
        <FsLightbox
          toggler={floorplanLightbox}
          sources={props.floorplans.map((floorplan) => floorplan.url)}
        />
      }
    </div>
  )
}

export default EventCard